import hotToast from "react-hot-toast";

// react-hot-toast(MIT) の薄いラッパー。
// 既存の呼び出し（toast.success / toast.error / toast.info / setToastMuted）を維持する。

let muted = false;

// 一括処理中などに一時的にトーストを抑制する（CSVインポート等）。
export function setToastMuted(value: boolean) {
  muted = value;
}

export const toast = {
  success: (message: string) => {
    if (!muted) hotToast.success(message);
  },
  error: (message: string) => {
    if (!muted) hotToast.error(message);
  },
  info: (message: string) => {
    if (!muted) hotToast(message);
  },
};
